module.exports = __webpack_public_path__ + "static/media/page-turn.c246524f.wav";